import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import WikiSidebar from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_sidebar.vue?vue3';

export const mountWikiSidebar = () => {
  const el = document.querySelector('#js-wiki-sidebar');
  if (!el) return false;

  const {
    hasCustomSidebar,
    canCreate,
    viewAllPagesPath,
    editing,
    customSidebarContent,
    editSidebarUrl,
    isEditingSidebar,
  } = el.dataset;

  return initVueApp({
    el,
    name: 'WikiSidebarRoot',
    provide: {
      hasCustomSidebar: parseBoolean(hasCustomSidebar),
      canCreate: parseBoolean(canCreate),
      sidebarPagesApi: gl.GfmAutoComplete.dataSources.wikis,
      viewAllPagesPath,
      editing,
      customSidebarContent,
      editSidebarUrl,
      isEditingSidebar: parseBoolean(isEditingSidebar),
    },
    component: WikiSidebar,
  });
};
